module.exports = __webpack_public_path__ + "img/新增承运商icon@2x.48ae204c.png";